module.exports = __webpack_public_path__ + "img/zeigling12.985dce68.jpg";